import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MartContext } from "../../contexts/MartContext";
import { AuthContext } from "../../contexts/AuthContext";

const DrugCard = ({ drug }) => {
  const navigate = useNavigate();
  const { userData } = useContext(AuthContext); // Check user login status
  const { addToCart } = useContext(MartContext); // Access cart functionality

  const handleAddToCart = () => {
    if (!userData) {
      // Redirect to login with intended return path
      navigate("/auth/login/buyer", {
        state: { redirectTo: "/dashboard/drugs" },
      });
    } else {
      // Add the drug to the cart
      addToCart(drug);
      navigate("/dashboard/drugs");
    }
  };

  return (
    <div className="flex flex-col items-center w-72 h-auto p-6 border border-gray-300 rounded-lg shadow-lg bg-white">
      <img
        src={drug.imageUrl}
        alt={drug.name}
        className="w-48 h-48 object-cover mb-4 rounded-lg"
      />
      <h3 className="text-xl font-semibold mb-2 text-center">{drug.name}</h3>
      <p className="text-center mb-2">
        <span className="font-bold">Price:</span> ${drug.price.toFixed(2)}
      </p>
      <p className="text-center mb-2">
        <span className="font-bold">Category:</span> {drug.category}
      </p>
      <p className="text-center mb-4">
        <span className="font-bold">Quantity:</span> {drug.stockQuantity}
      </p>
      <button
        className="px-4 py-2 w-full bg-green-500 text-white rounded-md transition-colors duration-200 hover:bg-green-600"
        onClick={handleAddToCart}
      >
        Add to Cart
      </button>
    </div>
  );
};

export default DrugCard;
